
import { Camera } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";

const ImageCaptureCard = () => {
  const navigate = useNavigate();
  
  return (
    <Card className="hover:shadow-lg transition-shadow">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Camera className="text-brand-500" />
          Image Capture
        </CardTitle>
        <CardDescription>
          Take a picture for analysis
        </CardDescription>
      </CardHeader>
      <CardContent className="flex justify-center p-6">
        <Button 
          className="h-24 w-24 rounded-full bg-brand-400 hover:bg-brand-500 text-white"
          onClick={() => navigate("/image-capture")}
        >
          <Camera size={32} />
        </Button>
      </CardContent>
      <CardFooter className="flex justify-center">
        <p className="text-sm text-muted-foreground text-center">
          Tap to start taking a picture
        </p>
      </CardFooter>
    </Card>
  );
};

export default ImageCaptureCard;
